import { useState } from 'react';
import axios from 'axios';
import { Button } from '../../../components/ui/button';
import { API, Card, money, useAdminGet, when } from './dsfApi';

const KINDS = [['', 'All'], ['dsf_bet', 'Bets'], ['dsf_win', 'Wins'], ['dsf_refund', 'Refunds']];
const LABEL = { dsf_bet: 'Bet', dsf_win: 'Win', dsf_refund: 'Refund' };

export const DsfRecordsCard = ({ userId, clearUser }) => {
    const [kind, setKind] = useState('');
    const [page, setPage] = useState(0);
    const q = `${kind ? `&kind=${kind}` : ''}${userId ? `&user_id=${userId}` : ''}`;
    const [data, load] = useAdminGet(`/admin/dsf/records?limit=100&skip=${page * 100}${q}`);
    const csv = async () => {
        const all = [];
        for (let skip = 0; skip < Math.min(data?.total || 0, 50000); skip += 5000) {
            const { data: d } = await axios.get(`${API}/admin/dsf/records?limit=5000&skip=${skip}${q}`, { withCredentials: true });
            all.push(...d.records);
        }
        const rows = [['time', 'player', 'email', 'type', 'amount', 'balance_after', 'description', 'ref'],
            ...all.map((r) => [r.created_at, r.name, r.email, r.transaction_type, r.amount, r.balance_after, r.description, r.dsf_ref])];
        const blob = new Blob([rows.map((r) => r.map((c) => `"${String(c ?? '').replace(/"/g, '""')}"`).join(',')).join('\n')], { type: 'text/csv' });
        const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'deep-sea-furtune-records.csv'; a.click();
    };
    return (
        <Card title={`Every bet & win${userId ? ' · one player' : ''}`} testid="dsf-records-card"
            right={<>
                {userId && <Button size="sm" variant="outline" className="border-white/15 text-white" onClick={clearUser} data-testid="dsf-records-clear-player">All players</Button>}
                {KINDS.map(([k, l]) => (
                    <button key={k || 'all'} type="button" onClick={() => { setKind(k); setPage(0); }} data-testid={`dsf-records-kind-${k || 'all'}`}
                        className={`rounded-full px-3 py-1 text-xs font-bold ${kind === k ? 'bg-[#39FF14] text-black' : 'bg-white/5 text-white/70'}`}>{l}</button>
                ))}
                <Button size="sm" variant="outline" className="border-white/15 text-white" onClick={csv} data-testid="dsf-records-csv">CSV</Button>
                <Button size="sm" variant="ghost" className="text-white/70" onClick={load} data-testid="dsf-records-refresh">Refresh</Button>
            </>}>
            <div className="max-h-[420px] overflow-auto">
                <table className="w-full text-sm text-[#cfd6dc]">
                    <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#A0AAB2]">
                        <th className="pb-2">Time</th><th className="pb-2">Player</th><th className="pb-2">Type</th><th className="pb-2 text-right">Amount</th><th className="pb-2 text-right">Balance after</th><th className="pb-2 pl-4">Detail</th>
                    </tr></thead>
                    <tbody>
                        {(data?.records || []).map((r) => (
                            <tr key={r.dsf_ref} className="border-t border-white/5" data-testid="dsf-record-row">
                                <td className="py-1 text-xs text-white/60">{when(r.created_at)}</td><td>{r.name || r.email}</td><td>{LABEL[r.transaction_type]}</td>
                                <td className={`text-right tabular-nums ${r.amount < 0 ? 'text-white/70' : 'text-[#39FF14]'}`}>{money(r.amount)}</td>
                                <td className="text-right tabular-nums text-white/60">{money(r.balance_after)}</td><td className="pl-4 text-xs text-white/50">{r.description}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {data && !data.records.length && <p className="py-4 text-center text-white/50">No records.</p>}
            </div>
            <div className="mt-2 flex items-center gap-2 text-xs text-white/50">
                <span data-testid="dsf-records-total">{data ? `${data.total.toLocaleString()} records` : ''}</span>
                <Button size="sm" variant="ghost" disabled={!page} onClick={() => setPage(page - 1)} data-testid="dsf-records-prev">Newer</Button>
                <Button size="sm" variant="ghost" disabled={!data || (page + 1) * 100 >= data.total} onClick={() => setPage(page + 1)} data-testid="dsf-records-next">Older</Button>
            </div>
        </Card>
    );
};
